exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".outer[data-v-2b04bed6]{display:table;width:100%;height:100%}.outer .inner[data-v-2b04bed6]{height:10px;display:table-cell;vertical-align:middle}.outer .inner .hr[data-v-2b04bed6]{border-top:4px solid #000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2b04bed6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/widgets/WidgetHR.vue
// module id = 102
// module chunks = 0